import React from "react";
import "./App.css";
import { AvistaProvider } from "./provider";
import { PageRouter } from "./router";

const App: React.FC = () => {
  return (
    <AvistaProvider>
      <PageRouter />
    </AvistaProvider>
  );
};

export default App;
